const bikeTabGroups = document.querySelectorAll("[data-bike-tabs]");
const tabsContentInfo = document.querySelectorAll(".nav-link-info");
const contentSectionsInfo = document.querySelectorAll(".content-section-info");
const differentWaysTab = document.querySelectorAll(".nav-different-ways-info");
const differentWaysContent = document.querySelectorAll(".way-section-info");
const contentCards = document.querySelectorAll(".content-bike-card");

if (bikeTabGroups.length > 0) {
  const MOBILE_BIKE_SHEET_ANIMATION_MS = 420;
  let mobileBikeOverlay = null;
  let mobileBikeSheet = null;
  let mobileBikeSheetBody = null;
  let mobileBikeSheetTitle = null;
  let mobileBikeOpenButton = null;
  let mobileBikeCloseTimer = null;

  const closeMobileBikeSheet = () => {
    if (!mobileBikeOverlay || !mobileBikeSheet) return;

    mobileBikeOverlay.classList.remove("is-open");
    mobileBikeSheet.classList.remove("is-open");
    if (mobileBikeCloseTimer) {
      window.clearTimeout(mobileBikeCloseTimer);
    }
    mobileBikeCloseTimer = window.setTimeout(() => {
      mobileBikeOverlay.classList.add("p-hidden");
    }, MOBILE_BIKE_SHEET_ANIMATION_MS);
    document.body.classList.remove("p-overflow-hidden");

    if (mobileBikeOpenButton) {
      mobileBikeOpenButton.setAttribute("aria-expanded", "false");
      mobileBikeOpenButton = null;
    }
  };

  const ensureMobileBikeSheet = () => {
    if (mobileBikeOverlay && mobileBikeSheet && mobileBikeSheetBody) return;

    mobileBikeOverlay = document.createElement("div");
    mobileBikeOverlay.className = "bike-mobile-overlay p-hidden";

    mobileBikeSheet = document.createElement("div");
    mobileBikeSheet.className = "bike-mobile-bottom-sheet";

    const sheetHeader = document.createElement("div");
    sheetHeader.className = "bike-mobile-bottom-sheet__header";

    mobileBikeSheetTitle = document.createElement("h4");
    mobileBikeSheetTitle.className = "bike-mobile-bottom-sheet__title";

    const closeButton = document.createElement("button");
    closeButton.type = "button";
    closeButton.className = "bike-mobile-bottom-sheet__close";
    closeButton.textContent = "X";
    closeButton.setAttribute("aria-label", "Cerrar");
    closeButton.addEventListener("click", closeMobileBikeSheet);

    sheetHeader.appendChild(mobileBikeSheetTitle);
    sheetHeader.appendChild(closeButton);

    mobileBikeSheetBody = document.createElement("div");
    mobileBikeSheetBody.className = "bike-mobile-bottom-sheet__body";

    mobileBikeSheet.appendChild(sheetHeader);
    mobileBikeSheet.appendChild(mobileBikeSheetBody);

    mobileBikeOverlay.appendChild(mobileBikeSheet);
    const landingBikeRoot = document.getElementById("landing-way-bike");
    (landingBikeRoot || document.body).appendChild(mobileBikeOverlay);

    mobileBikeOverlay.addEventListener("click", (event) => {
      if (event.target === mobileBikeOverlay) {
        closeMobileBikeSheet();
      }
    });
  };

  const openMobileBikeSheet = ({ title, description, features, triggerButton }) => {
    ensureMobileBikeSheet();
    if (!mobileBikeOverlay || !mobileBikeSheet || !mobileBikeSheetBody) return;

    if (!features) return;

    mobileBikeSheetBody.innerHTML = "";
    if (description) {
      const descriptionBlock = document.createElement("div");
      descriptionBlock.className = "bike-mobile-bottom-sheet__description";
      descriptionBlock.appendChild(description.cloneNode(true));
      mobileBikeSheetBody.appendChild(descriptionBlock);
    }
    mobileBikeSheetBody.appendChild(features.cloneNode(true));
    mobileBikeSheetTitle.textContent = title || "";

    if (mobileBikeOpenButton && mobileBikeOpenButton !== triggerButton) {
      mobileBikeOpenButton.setAttribute("aria-expanded", "false");
    }

    mobileBikeOpenButton = triggerButton || null;
    if (mobileBikeOpenButton) {
      mobileBikeOpenButton.setAttribute("aria-expanded", "true");
    }

    mobileBikeOverlay.classList.remove("p-hidden");
    requestAnimationFrame(() => {
      mobileBikeOverlay.classList.add("is-open");
      mobileBikeSheet.classList.add("is-open");
    });
    document.body.classList.add("p-overflow-hidden");
  };

  bikeTabGroups.forEach((tabsGroup) => {
    const groupName = tabsGroup.dataset.bikeTabs;
    const contentGroup = document.querySelector(
      `[data-bike-content="${groupName}"]`
    );

    if (!contentGroup) return;

    const tabs = tabsGroup.querySelectorAll(".nav-link-info");
    const groupInfoSections = contentGroup.querySelectorAll(".content-section-info");
    const groupCards = contentGroup.querySelectorAll(".content-bike-card");

    if (!tabs.length) return;

    const setActive = (tab) => {
      const targetId = tab.dataset.target;
      const imageCardId = tab.dataset.image;

      if (!targetId) return;

      tabs.forEach((t) => t.classList.remove("active"));
      groupInfoSections.forEach((info) => info.classList.add("p-hidden"));
      groupCards.forEach((card) => card.classList.add("p-hidden"));

      const targetSection = contentGroup.querySelector(`#${targetId}`);
      if (targetSection) {
        targetSection.classList.remove("p-hidden");
      }

      if (imageCardId) {
        const targetCard = contentGroup.querySelector(`#${imageCardId}`);
        if (targetCard) {
          targetCard.classList.remove("p-hidden");
        }
      }

      tab.classList.add("active");
    };

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => setActive(tab));
    });

    const defaultTab = tabsGroup.querySelector(".nav-link-info.active") || tabs[0];
    setActive(defaultTab);
  });

  const initMobileBikeSlider = () => {
    bikeTabGroups.forEach((tabsGroup) => {
      const groupName = tabsGroup.dataset.bikeTabs;
      const contentGroup = document.querySelector(
        `[data-bike-content="${groupName}"]`
      );

      if (!contentGroup) return;
      if (contentGroup.querySelector(".bike-mobile-slider")) return;

      const tabs = Array.from(tabsGroup.querySelectorAll(".nav-link-info"));
      if (!tabs.length) return;

      const heading = tabsGroup.querySelector(".type-bike");
      const slider = document.createElement("div");
      slider.className = "bike-mobile-slider";

      if (heading) {
        const headingClone = heading.cloneNode(true);
        headingClone.classList.add("bike-mobile-slider__title");
        slider.appendChild(headingClone);
      }

      const track = document.createElement("div");
      track.className = "bike-mobile-slider__track";

      tabs.forEach((tab) => {
        const targetId = tab.dataset.target;
        const imageCardId = tab.dataset.image;
        if (!targetId || !imageCardId) return;

        const info = contentGroup.querySelector(`#${targetId}`);
        const card = contentGroup.querySelector(`#${imageCardId}`);
        if (!info || !card) return;

        const titleNode = card.querySelector("h4");
        const imageNode = card.querySelector("img");
        const description = info.querySelector(":scope > div p");
        const features = info.querySelector(".section-features");

        const item = document.createElement("article");
        item.className = "bike-mobile-slide";

        const bikeName = document.createElement("h4");
        bikeName.className = "bike-mobile-slide__name";
        bikeName.textContent = titleNode ? titleNode.textContent.trim() : "";
        item.appendChild(bikeName);

        if (imageNode) {
          const imageClone = imageNode.cloneNode(true);
          imageClone.classList.add("bike-mobile-slide__img");
          item.appendChild(imageClone);
        }

        const actions = document.createElement("div");
        actions.className = "bike-mobile-slide__actions";

        const label = document.createElement("span");
        label.className = "bike-mobile-slide__label";
        label.textContent = tab.textContent.trim();

        const button = document.createElement("button");
        button.type = "button";
        button.className = "bike-mobile-slide__toggle";
        button.textContent = "+ info";
        button.setAttribute("aria-expanded", "false");

        actions.appendChild(label);
        actions.appendChild(button);
        item.appendChild(actions);

        button.addEventListener("click", () => {
          const isSameButtonOpen =
            mobileBikeOpenButton === button &&
            mobileBikeOverlay &&
            !mobileBikeOverlay.classList.contains("p-hidden");

          if (isSameButtonOpen) {
            closeMobileBikeSheet();
            return;
          }

          openMobileBikeSheet({
            title: bikeName.textContent.trim(),
            description,
            features,
            triggerButton: button,
          });
        });

        track.appendChild(item);
      });

      if (!track.children.length) return;

      slider.appendChild(track);
      contentGroup.prepend(slider);
    });
  };

  initMobileBikeSlider();
} else if (tabsContentInfo.length > 0) {
  tabsContentInfo.forEach((tab) => {
    tab.addEventListener("click", () => {
      const targetId = tab.dataset.target;
      const imageCardId = tab.dataset.image;

      if (!targetId) return;

      contentSectionsInfo.forEach((section) => section.classList.add("p-hidden"));
      contentCards.forEach((card) => card.classList.add("p-hidden"));
      tabsContentInfo.forEach((t) => t.classList.remove("active"));

      const targetSection = document.getElementById(targetId);
      if (targetSection) {
        targetSection.classList.remove("p-hidden");
      }

      if (imageCardId) {
        const targetCard = document.getElementById(imageCardId);
        if (targetCard) {
          targetCard.classList.remove("p-hidden");
        }
      }

      tab.classList.add("active");
    });
  });
}

if (differentWaysTab.length > 0) {
  differentWaysTab.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      differentWaysContent.forEach((section) => {
        section.classList.add("container-stages-hidden");
        section.classList.remove("container-stages");
      });

      differentWaysTab.forEach((t) => t.classList.remove("active"));

      if (differentWaysContent[index]) {
        differentWaysContent[index].classList.add("container-stages");
        differentWaysContent[index].classList.remove("container-stages-hidden");
      }

      const tabId = tab.id;
      const contentClass = tabId.replace("Tab", "Content");

      const allContents = document.querySelectorAll(
        ".sanXilContent, .samosContent"
      );
      allContents.forEach((content) => {
        content.classList.add("p-hidden");
      });

      const targetContents = document.querySelectorAll(`.${contentClass}`);
      targetContents.forEach((content) => {
        content.classList.remove("p-hidden");
      });

      tab.classList.add("active");
    });
  });
}
